export const MOBILE_APP_CONFIGURATION = `MOBILE_APP_CONFIGURATION`;
export const MOBILE_APP_LATEST_VERSION = `MOBILE_APP_LATEST_VERSION`;
export const MODAL_WAS_CLOSED = `MODAL_WAS_CLOSED`;
export const MODAL_WAS_CLOSED_COUNT = `MODAL_WAS_CLOSED_COUNT`;
export const MODAL_LAST_TIME_CLOSED = `MODAL_LAST_TIME_CLOSED`;
